import axios from 'api/axios-configure'
import { TableReport } from 'components/TableReport'
import format from 'date-fns/format'
import { Icon, Tooltip, Button} from 'monday-ui-react-core'
import React, { useContext, useEffect, useMemo, useRef, useState} from 'react'
import { Row } from 'react-bootstrap'
import { CardList, CircleFill } from 'react-bootstrap-icons'
import { useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { StatementContext } from 'utils/context/StatementsContext'
import { Usertype } from '../../utils/Constants'
import { getRowSelectionBaseKey } from 'utils/commonUtils'
import { DocumentTypes } from '../../utils/Constants'
import pdfIcon from './../../assest/images/pdf-icon.svg'
import { ProductBalancingAdvancedSearch } from './ProductBalancingAdvancedSearch'
import './ProductBalancing.scss'
import ProductBalancingForm from './ProductBalancingForm'
import ReceiverList from '../ReceiverList/ReceiverList'
import { AuthSessionContext } from 'api/AuthSession'
import UploadStatementsModalComponent from '../Modals/UploadStatementsModalComponent';
import UploadErrorModalComponent from '../Modals/UploadErrorModalComponent';
import excelIcon from './../../assest/images/excel-icon.svg'
import { LineChart } from "components/LineChartV2"
import { useLocation } from 'react-router-dom';


const ProductBalancing = ({
    type,
    uploadButtonClicked,
    setUploadButtonClicked
}) => {
    const location = useLocation();
    const stateData = location.state?.runData;

    const { getProductBalancingStatementPDF, getProductImbalanceStatementCSV, canUploadFileCurrentCompany, setCanUploadFileCurrentCompany} = useContext(StatementContext)
    const { IS_USER } = useContext(AuthSessionContext)
    const [searchParams] = useSearchParams()
    const [tableData, setTableData] = useState([])
    const [statementDates, setStatementDates] = useState([null,null])
    const [reportingMonthDates, setReportingMonthDates] = useState([new Date().setFullYear(new Date().getFullYear()-1),new Date()])
    const [selectedStatus, setSelectedStatus] = useState({value: 1})
    const [searchInput, setSearchInput] = useState('')
    const [showAdvancedSearch, setShowAdvancedSearch] = useState(false)
    const [operator, setOperator] = useState('')
    const [reportingCenter, setReportingCenter] = useState('')
    const [reportingCenterName, setReportingCenterName] = useState('')
    const [apiNumber, setApiNumber] = useState('')
    const [ownerNumber, setOwnerNumber] = useState('')
    const [ownerName, setOwnerName] = useState('')
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 25, //customize the default page size
    })
    const [columnVisibility, setColumnVisibility] = useState({
        runName: false,
        createdOn: false,
        reportingCenterType: false,
        field: false,
        reservoir: false,
        county: false,
        state: false,
        country: false,
        product: false,
        contactName: false,
        contactAddress1: false,
        contactAddress2: false,
        contactAddress3: false,
        contactEmail: false,
        ownerNumber: false,
        entitlementPercentage: false,
        currentEntitlement: false,
        currentDelivered: false,
        currentImbalance: false,
        imbalanceAdjustment: false,
        priorImbalance: false,
        unitOfMeasure: false,
        pressureBase: false,
        senderName: type === Usertype.SENDER ? false : true,
        ownerName1: type === Usertype.SENDER ? false : true,
        runName: false,
        runId: false,
        createdBy: false,
        documentReference: false,
        ownerName2: false,
        ownerAddress1: false,
        ownerAddress2: false,
        ownerAddress3: false,
        ownerCity: false,
        ownerState: false,
        ownerZip5: false,
        ownerZip4: false,
        senderName1: false,
        senderName2: false,
        senderAddress1: false,
        senderAddress2: false,
        senderAddress3: false,
        senderCity: false,
        senderState: false,
        senderZip5: false,
        senderZip4:false,
        contactPhone: false,
        referenceNumber: false,
        operatorNumber: false,
        senderNumber: false,
        documentType: false,
    })
    const [rowCount, setRowCount] = useState(0)
    const [sorting, setSorting] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [isFetching, setIsFetching] = useState(false)
    const [rowSelection, setRowSelection] = useState({})
    const [openModal, setOpenModal] = useState(false)
    const [docSysNumber, setDocSysNumber] = useState('')
    const [dataChart, setDataChart] = useState([])
    const [showChart, setShowChart] = useState(false)
    const [isReceiverWithMassDownload, setIsReceiverWithMassDownload] = useState(false)
    const [showErrorModal, setShowErrorModal] = useState(false)
    const inputFile = useRef(null)
    const [showUploadModal, setShowUploadModal] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)
    const [uploadError, setUploadError] = useState("")
    const [csvErrors, setCsvErrors] = useState()
    const [runNames, setRunNames] = useState([])
    const [runNameOptions, setRunNameOptions] = useState([])
    const isUnreadFiltered = useRef(false)
    const [selectedFilter, setSelectedFilter] = useState(2)
    
    const isMounted = useRef(false)
    const [errorMessage, setErrorMessage] = useState('')
    
    //need to put this into a seperate component, but for time going to duplicate it in both PO and PB
    const requestAvailableRuns = (companyNumber, product) => {
        axios
        .get(
            'GetAvailableRuns',
            {
                params: {
                    companyNumber: companyNumber,
                    product: product
                }
            }
        )
        .then((response) => {
            return setRunNameOptions(response.data);
        })
        .catch(() => {
            return '';
        })
    }

    const senderColumns = useMemo(
        () => [
            {
                header: 'Actions',
                size: 60,
                maxSize: 60,
                enableSorting: false,
                Cell: ({ row }) => {
                    const canDownloadCsv = row.original.hasDownloadFile
                    return (                  
                        <div className="d-flex align-items-center">
                            <Tooltip content="Download PDF">
                                <Icon
                                    iconSize={24}
                                    iconType={Icon.type.SRC}
                                    icon={pdfIcon}
                                    iconLabel="pdf icon"
                                    className="icon-story-custom-icon actions-icon"
                                    onClick={() =>
                                        handlePdfIconClick(row.original)
                                    }
                                />
                            </Tooltip>
                            {canDownloadCsv && (
                                <>
                                    <Icon
                                        iconSize={24}
                                        iconType={Icon.type.SRC}
                                        icon={excelIcon}
                                        iconLabel="my src awesome icon"
                                        className="icon-story-custom-icon excel-icon actions-icon"
                                        onClick={() => downloadSingleDocumentCSV(row.original)}
                                    />
                                </> 
                            )}
                            <Tooltip content="View Receiver List">
                                <CardList
                                    className="list-icon"
                                    size={15}
                                    onClick={() =>
                                        handleViewReceiverListOnClick(row.original.documenT_SYSTEM_NUMBER)
                                    }
                                ></CardList>
                            </Tooltip>
                        </div>
                                
                    )
                },
            },
            {
                accessorKey: 'reportingMonth',
                id: 'reportingMonth',
                header: 'Reporting Month',
                enableHide: false,
                Header: ({ column }) => (
                    <>
                        <div style={{height: 18 + 'px'}}>Reporting</div>
                        <div>Month</div>
                    </>
                ),
                Cell: (({cell}) => {
                    const dateString = cell.getValue()
                    const date = new Date(dateString)
                    const result = format(date, "MM/dd/yyyy")
                    return (
                        <>
                            {result}
                        </>
                    )
                }),
                minSize: 80,
                size: 80
            },
            {
                size: 130,
                maxSize: 130,
                accessorKey: 'runName',
                header: 'Run Name',
                Header:({column}) => (
                    <>
                        <div style={{height: 18 + 'px'}}>Run</div>
                        <div>Name</div>                        
                    </>
                )
            },
            {
                accessorKey: 'operatorName',
                header: 'Operator',
                size: 140,
                maxSize: 140,
            },
            {
                accessorKey: 'reportingCenter',
                size: 60,
                maxSize: 60,
                header: 'Reporting Center',
                Header: ({ column }) => (
                    <>
                    <div style={{height: 18 + 'px'}}>Reporting</div>
                    <div>Center</div>
                    </>
                ),
                minSize: 80
            },
            {
                accessorKey: 'reportingCenterName',
                header: 'Reporting Center Name',
                size: 120,
                Header: ({column}) => (
                    <>
                    <div style={{height: 18 + 'px'}}>Reporting</div>
                    <div>Center Name</div>
                    </>
                ),
            },
            {
                accessorKey: 'reportingCenterType',
                header: 'Reporting Center Type',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'statementDate',
                size: 60,
                maxSize: 60,
                header: 'Statement Date',
                Header: ({ column }) => (
                    <>
                        <div style={{height: 18 + 'px'}}>Statement</div>
                        <div>Date</div>
                    </>
                ),
                Cell: (({cell}) => {
                    const dateString = cell.getValue()
                    const date = new Date(dateString)
                    const result = format(date, "MM/dd/yyyy")
                    return (
                        <>
                            {result}
                        </>
                    )
                }),
                muiTableHeadCellProps: {
                    align: 'left',
                },
            },
            {
                accessorKey: 'status',
                size: 60,
                maxSize: 60,
                header: 'Status',
                Header: ({ column }) => (
                    <>
                        Status
                    </>
                ),
            },
            {
                accessorKey: 'createdOn',
                size: 60,
                maxSize: 60,
                header: 'Created On',
                Header: ({ column }) => (
                    <>
                        Created On
                    </>
                ),
            },
            {
                accessorKey: 'createdBy',
                size: 60,
                maxSize: 60,
                header: 'Created By',
                Header: ({ column }) => (
                    <>
                        Created By
                    </>
                ),
            },
            {
                accessorKey: 'documentReference',
                header: 'Reference',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'wellAPINumber',
                header: 'API Number',
                minSize: 80,
            },
            {
                accessorKey: 'field',
                header: 'Field',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'reservoir',
                header: 'Reservoir',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'county',
                header: 'County',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'state',
                header: 'State',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'country',
                header: 'Country',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'product',
                header: 'Product',
                size: 60,
                maxSize: 60,
            },
            {
                accessorKey: 'operatorNumber',
                header: 'Operator #',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'contactName',
                header: 'Contact Name',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'contactAddress1',
                header: 'Contact Address1',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'contactAddress2',
                header: 'Contact Address2',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'contactAddress3',
                header: 'Contact Address3',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'contactPhone',
                header: 'Contact Phone',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'contactEmail',
                header: 'Contact Email',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'ownerNumber',
                header: 'Owner Number',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'ownerName1',
                header: 'Owner Name',
                size: 100,
            },
            {
                accessorKey: 'ownerName2',
                header: 'Owner Name2',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'ownerAddress1',
                header: 'Owner Address1',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'ownerAddress2',
                header: 'Owner Address2',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'ownerAddress3',
                header: 'Owner Address3',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'ownerCity',
                header: 'Owner City',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'ownerState',
                header: 'Owner State',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'ownerZip5',
                header: 'Owner Zip5',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'ownerZip4',
                header: 'Owner Zip4',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'entitlementPercentage',
                header: 'Entitlement %',
                muiTableBodyCellProps: {
                    align: 'right',
                },
                muiTableHeadCellProps: ({ column }) => ({
                    align: 'right',
                }),
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'currentEntitlement',
                header: 'Current Entitlement',
                muiTableBodyCellProps: {
                    align: 'right',
                },
                muiTableHeadCellProps: ({ column }) => ({
                    align: 'right',
                }),
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'currentDelivered',
                header: 'Current Delivered',
                muiTableBodyCellProps: {
                    align: 'right',
                },
                muiTableHeadCellProps: ({ column }) => ({
                    align: 'right',
                }),
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'currentImbalance',
                header: 'Current Imbalance',
                muiTableBodyCellProps: {
                    align: 'right',
                },
                muiTableHeadCellProps: ({ column }) => ({
                    align: 'right',
                }),
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'imbalanceAdjustment',
                header: 'Imbalance Adjustment',
                muiTableBodyCellProps: {
                    align: 'right',
                },
                muiTableHeadCellProps: ({ column }) => ({
                    align: 'right',
                }),
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'priorImbalance',
                header: 'Prior Imbalance',
                muiTableBodyCellProps: {
                    align: 'right',
                },
                muiTableHeadCellProps: ({ column }) => ({
                    align: 'right',
                }),
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'cumulativeImbalance',
                size: 60,
                header: 'Cumulative Imbalance',
                muiTableBodyCellProps: {
                    align: 'right',
                },
                Header: ({column}) => (
                    <>
                    <div style={{height: 18 + 'px'}}>Cumulative</div>
                    <div>Imbalance</div>
                    </>
                ),
                muiTableHeadCellProps: ({ column }) => ({
                    align: 'right',
                }),
            },
            {
                accessorKey: 'unitOfMeasure',
                size: 60,
                header: 'UoM',
                muiTableBodyCellProps: {
                    align: 'center',
                },
                muiTableHeadCellProps: {
                    align: 'center',
                },
            },
            {
                accessorKey: 'pressureBase',
                header: 'Pressure Base',
                muiTableBodyCellProps: {
                    align: 'right',
                },
                muiTableHeadCellProps: ({ column }) => ({
                    align: 'right',
                }),
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'runId',
                header: 'Run Id',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'senderNumber',
                header: 'Sender Number',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'documentType',
                header: 'Document Type',
                size: 60,
                maxSize: 60,
            },
            {
                accessorKey: 'senderName1',
                header: 'Sender Name 1',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'senderName2',
                header: 'Sender Name 2',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'senderAddress1',
                header: 'Sender Address 1',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'senderAddress2',
                header: 'Sender Address 2',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'senderAddress3',
                header: 'Sender Address 3',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'senderCity',
                header: 'Sender City',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'senderState',
                header: 'Sender State',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'senderZip5',
                header: 'Sender Zip5',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'senderZip4',
                header: 'Sender Zip4',
                size: 100,
                maxSize: 100,
            },
        ],
        []
    )

    const receiverColumns = useMemo(
        () => [
            {
                header: '',
                size:2,
                maxSize: 2,
                enableSorting: false,
                accessorKey: 'hasDownloadedFile',
                Cell: ({row}) => {
                    return !row.original.hasDownloadedFile ? (
                        <div className='d-flex align-items-center'>
                            <Tooltip content='Unread'>
                                <CircleFill
                                    className='payout-icon'
                                    size={5}
                                />
                            </Tooltip>
                        </div>
                    ) : null
                }
            },
            {
                header: 'Actions',
                size: 60,
                maxSize: 60,
                enableSorting: false,
                Cell: ({ row }) => {
                    const canDownloadCsv = row.original.hasDownloadFile
                    return (
                        <div className="d-flex align-items-center">
                            <Tooltip content="Download PDF">
                                <Icon
                                    iconSize={24}
                                    iconType={Icon.type.SRC}
                                    icon={pdfIcon}
                                    iconLabel="pdf icon"
                                    className="icon-story-custom-icon actions-icon"
                                    onClick={() =>
                                        handlePdfIconClick(row.original)
                                    }
                                />
                            </Tooltip>
                            {canDownloadCsv && (
                                <>
                                    <Icon
                                        iconSize={24}
                                        iconType={Icon.type.SRC}
                                        icon={excelIcon}
                                        iconLabel="my src awesome icon"
                                        className="icon-story-custom-icon excel-icon actions-icon"
                                        onClick={() => downloadSingleDocumentCSV(row.original)}
                                    />
                                </> 
                            )}
                        </div>
                    )
                },
            },
            {
                className: 'month-css-style',
                accessorKey: 'reportingMonth',
                id: 'reportingMonth',
                header: 'Reporting Month',
                Header: ({ column }) => (
                    <>
                        <div style={{height: 18 + 'px'}}>Reporting</div>
                        <div>Month</div>
                    </>
                ),
                Cell: (({cell}) => {
                    const dateString = cell.getValue()
                    const date = new Date(dateString)
                    const result = format(date, "MM/dd/yyyy")
                    return (
                        <>
                            {result}
                        </>
                    )
                }),
                muiTableBodyCellProps: {
                    align: 'left',
                    className: 'month-css-style'
                },
                muiTableHeadCellProps: ({ column }) => ({
                    align: 'left',
                    className: 'month-css-style'
                }),
                size: 100,
                maxSize: 115
            },
            {
                accessorKey: 'operatorName',
                header: 'Operator',
                size: 140,
                maxSize: 140,
            },
            {
                accessorKey: 'reportingCenter',
                size: 100,
                maxSize: 100,
                header: 'Reporting Center',
                Header: ({ column }) => (
                    <>
                        <div style={{height: 18 + 'px'}}>Reporting</div>
                        <div>Center</div>
                    </>
                ),
                minSize: 80
            },
            {
                accessorKey: 'reportingCenterName',
                header: 'Reporting Center Name',
                size: 120,
                Header: ({column}) => (
                    <>
                    <div style={{height: 18 + 'px'}}>Reporting</div>
                    <div>Center Name</div>
                    </>
                ),
            },
            {
                accessorKey: 'reportingCenterType',
                header: 'Reporting Center Type',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'statementDate',
                size: 60,
                maxSize: 60,
                header: 'Statement Date',
                Header: ({ column }) => (
                    <>
                        <div style={{height: 18 + 'px'}}>Statement</div>
                        <div>Date</div>
                    </>
                ),
                Cell: (({cell}) => {
                    const dateString = cell.getValue()
                    const date = new Date(dateString)
                    const result = format(date, "MM/dd/yyyy")
                    return (
                        <>
                            {result}
                        </>
                    )
                }),
                muiTableHeadCellProps: {
                    align: 'left',
                },
            },
            {
                accessorKey: 'status',
                size: 60,
                maxSize: 60,
                header: 'Status',
                Header: ({ column }) => (
                    <>
                        Status
                    </>
                ),
            },
            {
                accessorKey: 'createdOn',
                size: 60,
                maxSize: 60,
                header: 'Created On',
                Header: ({ column }) => (
                    <>
                        Created On
                    </>
                ),
            },
            {
                accessorKey: 'wellAPINumber',
                header: 'API Number',
                minSize: 120,
            },
            {
                accessorKey: 'field',
                header: 'Field',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'reservoir',
                header: 'Reservoir',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'county',
                header: 'County',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'state',
                header: 'State',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'country',
                header: 'Country',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'product',
                header: 'Product',
                size: 60,
                maxSize: 60,
            },
            {
                accessorKey: 'contactName',
                header: 'Contact Name',
                size: 100,
                maxSize: 100,     
            },
            {
                accessorKey: 'contactAddress1',
                header: 'Contact Address1',
                size: 100,
                maxSize: 100,                 
            },
            {
                accessorKey: 'contactAddress2',
                header: 'Contact Address2',
                size: 100,
                maxSize: 100,                 
            },
            {
                accessorKey: 'contactAddress3',
                header: 'Contact Address3',
                size: 100,
                maxSize: 100,                 
            },
            {
                accessorKey: 'contactPhone',
                header: 'Contact Phone',
                size: 100,
                maxSize: 100,                
            },
            {
                accessorKey: 'contactEmail',
                header: 'Contact Email',
                size: 100,
                maxSize: 100,                 
            },
            {
                accessorKey: 'ownerNumber',
                header: 'Owner Number',
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'ownerName1',
                header: 'Owner Name',
                size: 100,
            },
            {
                accessorKey: 'entitlementPercentage',
                header: 'Entitlement %',
                muiTableBodyCellProps: {
                    align: 'right',
                },
                muiTableHeadCellProps: ({ column }) => ({
                    align: 'right',
                }),
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'currentEntitlement',
                header: 'Current Entitlement',
                muiTableBodyCellProps: {
                    align: 'right',
                },
                muiTableHeadCellProps: ({ column }) => ({
                    align: 'right',
                }),
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'currentDelivered',
                header: 'Current Delivered',
                muiTableBodyCellProps: {
                    align: 'right',
                },
                muiTableHeadCellProps: ({ column }) => ({
                    align: 'right',
                }),
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'currentImbalance',
                header: 'Current Imbalance',
                muiTableBodyCellProps: {
                    align: 'right',
                },
                muiTableHeadCellProps: ({ column }) => ({
                    align: 'right',
                }),
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'imbalanceAdjustment',
                header: 'Imbalance Adjustment',
                muiTableBodyCellProps: {
                    align: 'right',
                },
                muiTableHeadCellProps: ({ column }) => ({
                    align: 'right',
                }),
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'priorImbalance',
                header: 'Prior Imbalance',
                muiTableBodyCellProps: {
                    align: 'right',
                },
                muiTableHeadCellProps: ({ column }) => ({
                    align: 'right',
                }),
                size: 100,
                maxSize: 100,
            },
            {
                accessorKey: 'cumulativeImbalance',
                size: 80,
                header: 'Cumulative Imbalance',
                muiTableBodyCellProps: {
                    align: 'right',
                },
                Header: ({column}) => (
                    <>
                    <div style={{height: 18 + 'px'}}>Cumulative</div>
                    <div>Imbalance</div>
                    </>
                ),
                muiTableHeadCellProps: ({ column }) => ({
                    align: 'right',
                }),
            },
            {
                accessorKey: 'unitOfMeasure',
                size: 60,
                header: 'UoM',
                muiTableBodyCellProps: {
                    align: 'center',
                },
                muiTableHeadCellProps: {
                    align: 'center',
                },
            },
            {
                accessorKey: 'pressureBase',
                header: 'Pressure Base',
                muiTableBodyCellProps: {
                    align: 'right',
                },
                muiTableHeadCellProps: ({ column }) => ({
                    align: 'right',
                }),
                size: 100,
                maxSize: 100,
            },
        ],
        []
    )


    const pageLoad = (isRefetch) => {
        let pbAdvancedSearch = getAdvancedSearchValues()

        if (pbAdvancedSearch.senderNumber){
            requestAvailableRuns(pbAdvancedSearch.senderNumber, DocumentTypes.PRODUCT_BALANCING);
        }
        
        if (stateData && stateData.runData){
            setRunNames(stateData.runData)
            
            setShowAdvancedSearch(true)

            setReportingMonthDates([null, null])
            pbAdvancedSearch.reportingMonthFrom = null
            pbAdvancedSearch.reportingMonthTo = null
        }

        GetProductBalancingAllStatementsPaginated(pbAdvancedSearch, isRefetch)
        
    }

    const partialPageLoad = () => {
        if (type === Usertype.RECEIVER) {
            pageLoad(true)
        }
    }

    useEffect(() =>{       
        pageLoad()
        const pbAdvancedSearch = getAdvancedSearchValues()   
        if(type===Usertype.SENDER){
            axios
                .get(
                    'GetUserUploadPermissionForCompanyAndDocType',
                    {
                        params: {
                            senderNumber: pbAdvancedSearch.senderNumber,
                            documentType: DocumentTypes.PRODUCT_BALANCING,
                        },
                    }
                )
                .then((response) => {
                    setCanUploadFileCurrentCompany(response.data)
                })
                .catch(() => {
                    setCanUploadFileCurrentCompany(false)
                })
        }
        window.addEventListener('PdfDownloadComplete', partialPageLoad)
        return () => window.removeEventListener('PdfDownloadComplete', partialPageLoad)
    }, [])

    useEffect(() => {
        if (isMounted.current) {
            const pbAdvancedSearch = getAdvancedSearchValues()
            GetProductBalancingAllStatementsPaginated(pbAdvancedSearch)
        }
    }, [pagination.pageIndex, pagination.pageSizea])

    useEffect(() => {
        if (isMounted.current) {
            const pbAdvancedSearch = getAdvancedSearchValues()
            GetProductBalancingAllStatementsPaginated(pbAdvancedSearch)
        }
    }, [sorting])

    useEffect(() => {
        if (isMounted.current) {
            setShowUploadModal(uploadButtonClicked)
        }
    }, [uploadButtonClicked])

    useEffect(() => {
        if (isMounted.current) {
            setColumnVisibility(columnVisibility) //programmatically show firstName column
        }
    }, [columnVisibility])

    useEffect(() => {
        if (isMounted.current) {
            if (pagination.pageIndex === 0) {
                const pbAdvancedSearch = getAdvancedSearchValues()
                GetProductBalancingAllStatementsPaginated(pbAdvancedSearch)
            } else {
                setPagination({ pageIndex: 0, pageSize: pagination.pageSize })
            }
        }
    }, [selectedStatus])

    const GetProductBalancingAllStatementsPaginated = (pbAdvancedSearch, isRefetch) => {
        var data = pbAdvancedSearch
        var url = ''
        if (type === Usertype.SENDER) {
            url = '/GetSenderStatementsFullInfo'
        }
        if (type === Usertype.RECEIVER) {
            url = '/GetReceiverStatementsFullInfo'
        }

        if (!tableData.length || !isRefetch)
            setIsLoading(true)
        else
            setIsFetching(true)
        axios
            .post(url, data)
            .then((response) => {
                setIsReceiverWithMassDownload(response.data.hasPDFMassDownload)
                setDataChart(response.data.chartData)
                setTableData(response.data.statements.items)
                setRowCount(response.data.statements.totalCount)
                isMounted.current = true
            })
            .catch((error) => {
                //setErrorMessage(error.response.data.errors.GlobalSearch[0])
                setIsLoading(false)
                setIsFetching(false)
                
            })
            .finally(() => {
                setIsLoading(false)
                setIsFetching(false)
            })
    }

    const showDownloadToast = (fileType) => {
        toast.success(`Downloading ${fileType}`, {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: 'toastify__toast--success-custom',
            bodyClassName: 'toastify-body',
            progressClassName: 'toastify-progress-bar',
        })
    }

    const handlePdfIconClick = (row) => {
        showDownloadToast('PDF')
        const { documenT_SYSTEM_NUMBER, runId, ownerName1 } = row
        const postData = []
        const data = {
            documentSystemNumber: documenT_SYSTEM_NUMBER,
            ownerName: ownerName1,
            runId,
        }
        postData.push(data)

        if (postData.length) {
            getProductBalancingStatementPDF(postData, type)
        }
    }

    const handleSearchChange = (value) => {
        setSearchInput(value.trim())
    }

    const getAdvancedSearchValues = () => {
        const searchParamsObj = Object.fromEntries([...searchParams])
        const { senderNumber } = searchParamsObj

        const pbAdvancedSearch = {
            senderNumber: senderNumber,
            status: selectedStatus?.value,
            pageNumber: pagination.pageIndex + 1,
            pageSize: pagination.pageSize,
            sortDesc: sorting[0]?.desc,
            SortBy: sorting[0]?.id,
            reportingMonthFrom: reportingMonthDates?.[0] !== null ? new Date(reportingMonthDates?.[0]) : null,
            reportingMonthTo: reportingMonthDates?.[1] !== null ? new Date(reportingMonthDates?.[1]) : null,
            statementDateFrom: statementDates?.[0] !== null ? new Date(statementDates?.[0]) : null,
            statementDateTo: statementDates?.[1] !== null ? new Date(statementDates?.[1]) : null,
            operator: operator,
            reportingCenter: reportingCenter,
            apiNumber: apiNumber,
            ownerNumber: ownerNumber,
            ownerName: ownerName,
            reportingCenterName: reportingCenterName,
            filterByUnreadDocument: isUnreadFiltered.current,
            globalSearch: searchInput,
            isCurrentOnly: selectedStatus?.value === 2,
            runNames: stateData ? stateData.runData : runNames ? runNames : null
        }

        return pbAdvancedSearch
    }
    const cleanRunNameInput = () => {
        setRunNames([])
        if (stateData && stateData.runData)
            stateData.runData = [];
    }
    const cleanAdvancedSearchInputs = () => { 
        setStatementDates([null, null])
        setOperator('')
        setReportingCenter('')
        setReportingCenterName('')
        setApiNumber('')
        setOwnerNumber('')
        setOwnerName('')
        cleanRunNameInput()
    }

    const handleSearchSubmit = () => {
        setPagination({ pageIndex: 0, pageSize: pagination.pageSize })
        const pbAdvancedSearch = getAdvancedSearchValues()
        GetProductBalancingAllStatementsPaginated(pbAdvancedSearch)
        setErrorMessage('')
    }

    const handleOpenModal = () => {
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const handleViewReceiverListOnClick = (documentSystemNumber) => {
        setDocSysNumber(documentSystemNumber)
        handleOpenModal()
    }

    const onDownloadButtonClicked = (rows, selectedRadio) => {
        const selectedRows = Object.keys(rows)
        const postData = selectedRows.map(row => {
            const splittedKey = getRowSelectionBaseKey(row).split(',')
            return {
                documentSystemNumber: splittedKey[0],
                runId: splittedKey[1],
                ownerName: splittedKey[2] ?? ''
            }
        })
        if(selectedRadio === "pdf") {
            showDownloadToast("PDF")
            getProductBalancingStatementPDF(postData, type)
        }else if (selectedRadio === "csv") {
            showDownloadToast("CSV")
            const csvData = {
                isSender: type===Usertype.SENDER,
                downloadDocuments: postData
            }
            getProductImbalanceStatementCSV(csvData)
        }
    }

    const downloadSingleDocumentCSV = (row) => {
        showDownloadToast("CSV")
        const { documenT_SYSTEM_NUMBER, ownerName, runId } = row
        const data = {
            isSender: type===Usertype.SENDER,
            downloadDocuments: [
                {
                    documentSystemNumber: documenT_SYSTEM_NUMBER,
                    ownerName: ownerName ? ownerName : "",
                    runId,
                }
            ]
        }

        if (data.downloadDocuments.length === 1) {
            getProductImbalanceStatementCSV(data)
        }
    }

    const showUploadToast = () => {
        toast.success(`Uploading the file`, {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: 'toastify__toast--success-custom',
            bodyClassName: 'toastify-body',
            progressClassName: 'toastify-progress-bar',
            autoClose: false,
        })
    }

    const showSuccessUploadToast = () => {
        toast.success(`File Uploaded successfully.`, {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: 'toastify__toast--success-custom',
            bodyClassName: 'toastify-body',
            progressClassName: 'toastify-progress-bar',
        })
    }
    
    const handleFileInputClick = () => {
        const file = inputFile.current.files[0]
        const fileExtension = file.name.split('.').pop().toLowerCase()
        if (fileExtension === 'csv' || fileExtension === 'xlsx') {
            setSelectedFile(inputFile.current.files[0])
            setUploadError('')
        } else {
            setUploadError('Only CSV and Excel files are supported.')
        }
    }

    const handleUploadClick = () => {
        if (selectedFile) {
            const formData = new FormData()
            formData.append('file', selectedFile, selectedFile.name)
            showUploadToast()
            axios
                .post('/UploadProductBalancingStatementsFromFile', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then(() => {
                    toast.dismiss()
                    closeUploadModal()
                    showSuccessUploadToast()
                    const pbAdvancedSearch = getAdvancedSearchValues()
                    GetProductBalancingAllStatementsPaginated(pbAdvancedSearch)                    
                })
                .catch(({ response }) => {
                    toast.dismiss()
                    handleCsvErrors(response.data)
                })
        }
    }

    const closeUploadModal = () => {
        inputFile.current.value = null
        setSelectedFile(null)
        setShowUploadModal(false)
        setUploadError('')
        setUploadButtonClicked(false)
    }

    const handleCsvErrors = (errorMessage) => {
        setCsvErrors(errorMessage)
        setShowErrorModal(true)
    }

    const closeErrorModal = () => {
        setShowErrorModal(false)
        setCsvErrors(undefined)
    }

    return (
        <>
            <div>
            {type === "sender" &&
                canUploadFileCurrentCompany && (
                    <Button
                        className={`upload-button ml-auto btn-custom-height visible`}
                        onClick={() => setShowUploadModal(true)}
                    >
                        Upload Statements
                    </Button>
                )
            }
            </div>
            <Row>
                <ProductBalancingForm
                    showAdvancedSearch={showAdvancedSearch}
                    setShowAdvancedSearch={setShowAdvancedSearch}
                    setReportingMonthDates={setReportingMonthDates}
                    handleSearchSubmit={handleSearchSubmit}
                    setSelectedStatus={setSelectedStatus}
                    selectedStatus={selectedStatus}
                    setShowChart={setShowChart}
                    showChart={showChart}
                    handleSearchChange={handleSearchChange}
                    cleanAdvancedSearchInputs={cleanAdvancedSearchInputs}
                    type={type}
                    isUnreadFiltered={isUnreadFiltered}
                    onTabChange={partialPageLoad}
                    reportingMonthFromValue={(reportingMonthDates?.[0] === null ? null : new Date(reportingMonthDates?.[0]))}
                    reportingMonthToValue={(reportingMonthDates?.[1] === null ? null : new Date(reportingMonthDates?.[1]))}
                    errorMessage={errorMessage}
                    searchString={searchInput}
                />
            </Row>
            {showAdvancedSearch && (
                <Row>
                    <ProductBalancingAdvancedSearch
                        setStatementDates={setStatementDates}
                        statementDateFrom={(statementDates?.[0] === null ? null : new Date(statementDates?.[0]))}
                        statementDateTo={(statementDates?.[1] === null ? null : new Date(statementDates?.[1]))}
                        setOperator={setOperator}
                        setReportingCenter={setReportingCenter}
                        setReportingCenterName={setReportingCenterName}
                        setApiNumber={setApiNumber}
                        setOwnerNumber={setOwnerNumber}
                        setOwnerName={setOwnerName}
                        setRunNames={setRunNames}
                        runNameOptions={runNameOptions}
                        runNames={runNames}
                        type={type}
                        onClear={cleanRunNameInput}
                    />
                </Row>
            )}
            {/*status 2 = past & current */} 
            {selectedStatus.value === 2 && (
                    <section className="graph-container">
                        <LineChart
                            dataChart={dataChart}
                            selectedFilter={selectedFilter}
                            showChart={showChart}
                        />
                    </section>
                )}  
            <Row>
                {/*We might want to move this up, for now we will leave it on the table*/}
                <section className="statements-container mb-5">
                    <div className="table-wrapper">
                        <TableReport
                            actionButtonLabel={'Download'}
                            enableManualSorting={true}
                            setColumnVisibility={setColumnVisibility}
                            onPaginationChange={setPagination}
                            pagination={pagination}
                            sorting={sorting}
                            onSortingChange={setSorting}
                            enableRowSelection={true}
                            hasMassDownload={
                                type === Usertype.SENDER || isReceiverWithMassDownload
                            }
                            enableHide={type === Usertype.SENDER && !IS_USER}
                            rowCount={rowCount}
                            columnVisibility={columnVisibility}
                            columns={
                                type === Usertype.SENDER
                                    ? senderColumns
                                    : receiverColumns
                            }
                            tableData={tableData}
                            onDownloadButtonClicked={
                                onDownloadButtonClicked
                            }
                            rowId={(row) => { 
                                if(tableData.length > 0)
                                    return (row.documenT_SYSTEM_NUMBER ?? '') + ',' + (row.runId ?? '') + ',' + (row.ownerName1 ?? '') + ',' + (row.status ?? '') + ',' + (row.hasDownloadFile)
                            }}
                            setRowSelection={setRowSelection}
                            rowSelection={rowSelection}
                            isLoading={isLoading}
                            isFetching={isFetching}
                        />
                    </div>
                </section>
            </Row>
            {openModal && (
                <ReceiverList
                    type={type}
                    open={openModal}
                    onClose={handleCloseModal}
                    documentSystemNumber={docSysNumber}
                    statementType={DocumentTypes.PRODUCT_BALANCING}
                    hasMassDownload={
                        type === Usertype.SENDER || isReceiverWithMassDownload
                    }
                />
            )}
            {type === 'sender' && showUploadModal && (
                <UploadStatementsModalComponent 
                    showModal={showUploadModal}
                    closeModal={closeUploadModal}
                    inputFileRef={inputFile}
                    selectedFile={selectedFile}
                    uploadError={uploadError}
                    handleFileInputClick={handleFileInputClick}
                    handleUploadClick={handleUploadClick}
                />
            )}

            {showErrorModal && (
                <UploadErrorModalComponent 
                    showModal={showErrorModal}
                    closeModal={closeErrorModal}
                    csvErrors={csvErrors}
                />
            )}
        </>
    )
}

export default ProductBalancing
